import Purecss from "purecss";

import Vue from "vue";

import App from "@/App.vue";
import router from "@/router";
import store from "@/store";
import VModal from "vue-js-modal";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import ECharts from "vue-echarts";
import Toasted from 'vue-toasted';

import { library } from "@fortawesome/fontawesome-svg-core";

import VueSimpleAlert from "vue-simple-alert";
import vuelidate from "vuelidate";

import VueFormWizard from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "echarts/lib/chart/bar";
import "echarts/lib/component/tooltip";
import {
  faArrowCircleLeft,
  faArrowUp,
  faArrowDown,
  faArrowRight,
  faArrowLeft,
  faChevronUp,
  faChevronDown,
  faChevronRight,
  faChevronLeft,
  faAt,
  faChartLine,
  faChartPie,
  faCheck,
  faComments,
  faEdit,
  faEnvelope,
  faEyeSlash,
  faFileDownload,
  faFileSignature,
  faHandshake,
  faInfoCircle,
  faLink,
  faLock,
  faPencilAlt,
  faPlay,
  faPoll,
  faQuestionCircle,
  faRoute,
  faTimesCircle,
  faTrashAlt,
  faUser,
  faUserCircle,
  faUserSecret,
  faAngleLeft,
  faAngleRight,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(
  faArrowCircleLeft,
  faArrowUp,
  faArrowDown,
  faArrowRight,
  faArrowLeft,
  faChevronUp,
  faChevronDown,
  faChevronRight,
  faChevronLeft,
  faAt,
  faChartLine,
  faChartPie,
  faCheck,
  faComments,
  faEdit,
  faEnvelope,
  faEyeSlash,
  faFileDownload,
  faFileSignature,
  faHandshake,
  faInfoCircle,
  faLink,
  faLock,
  faPencilAlt,
  faPlay,
  faPoll,
  faQuestionCircle,
  faRoute,
  faTimesCircle,
  faTrashAlt,
  faUser,
  faUserCircle,
  faUserSecret,
  faAngleLeft,
  faAngleRight,
);

Vue.use(VueSimpleAlert);
Vue.use(BootstrapVue);
Vue.use(VModal);
Vue.use(IconsPlugin);
Vue.use(VueFormWizard);
Vue.use(vuelidate);
Vue.use(Toasted, {
  position: 'bottom-right',
  duration: 6000,
  type: 'success'
});
Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.component("v-chart", ECharts);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
